// extracted by mini-css-extract-plugin
module.exports = {"popup-header-title":"colorHeading_popup-header-title__38CYL","title-underline-container":"colorHeading_title-underline-container__2c_HZ"};